import { render, staticRenderFns } from "./CodigosLibrosComponent2.vue?vue&type=template&id=d17d4db6"
import script from "./CodigosLibrosComponent2.vue?vue&type=script&lang=js"
export * from "./CodigosLibrosComponent2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports